import { useTranslation } from "react-i18next";
import type { TablePaginationActionsProps } from "@mui/material/TablePaginationActions";
import {
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid-pro";

import IconButton from "features/components/IconButton";
import NextIcon from "features/ui/Icons/NextIcon";
import PreviousIcon from "features/ui/Icons/PreviousIcon";

interface CustomPaginationActions extends TablePaginationActionsProps {
  onNextPage?: () => void;
  onPreviousPage?: () => void;
  hasNextPage: boolean;
  hasPrevPage: boolean;
}

const CustomPaginationActions = (props: any) => {
  const { t } = useTranslation("common");
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);

  const handleBack = () => {
    apiRef.current.setPage(page - 1);
    props?.onPreviousPage();
  };
  const handleNext = () => {
    apiRef.current.setPage(page + 1);
    props?.onNextPage();
  };

  return (
    <div className="flex items-center gap-2.5">
      <IconButton
        onClick={handleBack}
        disabled={!props.hasPrevPage}
        aria-label={t("material_table.previous_page")}
        color="tertiary"
        size="small"
      >
        <PreviousIcon />
      </IconButton>
      <IconButton
        onClick={handleNext}
        disabled={!props.hasNextPage}
        aria-label={t("material_table.next_page")}
        color="tertiary"
        size="small"
      >
        <NextIcon />
      </IconButton>
    </div>
  );
};

export default CustomPaginationActions;
